import AnimatedLoaderIcon from '@/icons/AnimatedLoader';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const LoadingOverlay = () => (
    <LoaderWrapper
        initial={{
            opacity: 0,
        }}
        animate={{
            opacity: 1,
        }}
        exit={{
            opacity: 0,
        }}
        transition={{ duration: 0.2, delay: 0.2 }}
    >
        <AnimatedLoaderIcon />
    </LoaderWrapper>
);

export const LoaderWrapper = styled(motion.div)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 12px;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.navy60};
    z-index: 10000;
`;
